import { render, staticRenderFns } from "./DispatchHeader.vue?vue&type=template&id=1480f53a&scoped=true&"
import script from "./DispatchHeader.vue?vue&type=script&lang=js&"
export * from "./DispatchHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480f53a",
  null
  
)

export default component.exports